module.exports = __webpack_public_path__ + "static/media/impatient-person-waiting-svgrepo-com.1e586149.svg";